export default __webpack_public_path__ + "2fba90968d20c30e727cb1deac0165bc.png";